import { render, staticRenderFns } from "./FacilityRepairRegistration.vue?vue&type=template&id=5a35d89e&scoped=true&"
import script from "./FacilityRepairRegistration.vue?vue&type=script&lang=js&"
export * from "./FacilityRepairRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FacilityRepairRegistration.vue?vue&type=style&index=0&id=5a35d89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35d89e",
  null
  
)

export default component.exports